module.exports = __webpack_public_path__ + "fdc23737cd11f22e413c65496677e232.glb";